import { Form } from "react-bootstrap";
import { CommunicationLanguage } from "@/briefpoint-client";
import styles from "./ReviewClientTasksClientLanguageSection.module.scss";

type ReviewClientTasksClientLanguageSectionProps = {
  language: CommunicationLanguage;
  isLanguageControlsDisabled: boolean;
  onSelectEnglish: () => void;
  onSelectSpanish: () => void;
};

export default function ReviewClientTasksClientLanguageSection(
  props: ReviewClientTasksClientLanguageSectionProps,
) {
  return (
    <div className={styles.languageBlock}>
      <div>
        <label htmlFor="select-english" className="fs-6 fw-bold mb-0">
          Client's Primary Language
        </label>
      </div>
      <div className={styles.radioRow}>
        <Form.Check
          label="English"
          type="radio"
          inline
          disabled={props.isLanguageControlsDisabled}
          checked={props.language === CommunicationLanguage.EN}
          onChange={props.onSelectEnglish}
          id="select-english"
        />
        <Form.Check
          label="Spanish"
          type="radio"
          inline
          disabled={props.isLanguageControlsDisabled}
          checked={props.language === CommunicationLanguage.ES}
          onChange={props.onSelectSpanish}
          id="select-spanish"
        />
      </div>
    </div>
  );
}
